import React from "react";
import styles from "./footer.module.css";

export const Footer = () => {
  const handleClick = (e) => {
    e.preventDefault();
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <footer className={styles.footerContainer}>
      <div className={styles.footerTextContainer}> 
      </div>
      <a className={styles.footerLinkHeader} href="/" onClick={handleClick}>
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M12 19V5M5 12L12 5L19 12" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
      </a>
    </footer>
  );
};
